import { Box, BoxProps } from "@chakra-ui/react";
import { FaTwitter } from "react-icons/fa";

export const href = "https://twitter.com/MyAreaHub";

export type Twitter_T = BoxProps;

export const Twitter = (props: Twitter_T) => {
  return <Box as={FaTwitter} aria-label="Twitter" fill="twitter" {...props} />;
};
